import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MessageCreateTemplate } from 'components/Templates'

const MessageCreate: FC = () => {
  return (
    <Layout headline={'メッセージ配信'} iconPath={'/icon/white/message.svg'} title={'メッセージ配信'}>
      <MessageCreateTemplate />
    </Layout>
  )
}

export default MessageCreate
